// extracted by mini-css-extract-plugin
export default {"fileName":"Filename_fileName__gERzf","removeIcon":"Filename_removeIcon__Alp-Y"};